/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/UserCompanyAccess', 'model/UserCompanyAccessReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/UserCompanyAccess'), require('../model/UserCompanyAccessReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserCompanyAccessApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.UserCompanyAccess, root.ForStractionServiceApi.UserCompanyAccessReport);
  }
}(this, function(ApiClient, UserCompanyAccess, UserCompanyAccessReport) {
  'use strict';

  /**
   * UserCompanyAccess service.
   * @module api/UserCompanyAccessApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new UserCompanyAccessApi. 
   * @alias module:api/UserCompanyAccessApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the userCompanyAccessAddPut operation.
     * @callback module:api/UserCompanyAccessApi~userCompanyAccessAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/UserCompanyAccess} body 
     * @param {module:api/UserCompanyAccessApi~userCompanyAccessAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.userCompanyAccessAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyAccessAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userCompanyAccessAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/UserCompanyAccess/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyAccessChangeCurrentCompanyGet operation.
     * @callback module:api/UserCompanyAccessApi~userCompanyAccessChangeCurrentCompanyGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserCompanyAccess} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * changeCurrentCompany
     * @param {String} _4SAPIAppID 
     * @param {Integer} toCompanyID 
     * @param {module:api/UserCompanyAccessApi~userCompanyAccessChangeCurrentCompanyGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserCompanyAccess}
     */
    this.userCompanyAccessChangeCurrentCompanyGet = function(_4SAPIAppID, toCompanyID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyAccessChangeCurrentCompanyGet";
      }

      // verify the required parameter 'toCompanyID' is set
      if (toCompanyID == undefined || toCompanyID == null) {
        throw "Missing the required parameter 'toCompanyID' when calling userCompanyAccessChangeCurrentCompanyGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'toCompanyID': toCompanyID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = UserCompanyAccess;

      return this.apiClient.callApi(
        '/UserCompanyAccess/changeCurrentCompany', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyAccessDeleteGet operation.
     * @callback module:api/UserCompanyAccessApi~userCompanyAccessDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/UserCompanyAccessApi~userCompanyAccessDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userCompanyAccessDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyAccessDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling userCompanyAccessDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/UserCompanyAccess/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyAccessLoadCurrentCompanyAccessesGet operation.
     * @callback module:api/UserCompanyAccessApi~userCompanyAccessLoadCurrentCompanyAccessesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/UserCompanyAccess>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadCurrentCompanyAccesses
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserCompanyAccessApi~userCompanyAccessLoadCurrentCompanyAccessesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/UserCompanyAccess>}
     */
    this.userCompanyAccessLoadCurrentCompanyAccessesGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyAccessLoadCurrentCompanyAccessesGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [UserCompanyAccess];

      return this.apiClient.callApi(
        '/UserCompanyAccess/loadCurrentCompanyAccesses', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyAccessLoadCurrentUserAccessesGet operation.
     * @callback module:api/UserCompanyAccessApi~userCompanyAccessLoadCurrentUserAccessesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/UserCompanyAccessReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadCurrentUserAccesses
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserCompanyAccessApi~userCompanyAccessLoadCurrentUserAccessesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/UserCompanyAccessReport>}
     */
    this.userCompanyAccessLoadCurrentUserAccessesGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyAccessLoadCurrentUserAccessesGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [UserCompanyAccessReport];

      return this.apiClient.callApi(
        '/UserCompanyAccess/loadCurrentUserAccesses', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyAccessLoadMyAccessGet operation.
     * @callback module:api/UserCompanyAccessApi~userCompanyAccessLoadMyAccessGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/UserCompanyAccessReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadMyAccess
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserCompanyAccessApi~userCompanyAccessLoadMyAccessGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/UserCompanyAccessReport>}
     */
    this.userCompanyAccessLoadMyAccessGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyAccessLoadMyAccessGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [UserCompanyAccessReport];

      return this.apiClient.callApi(
        '/UserCompanyAccess/loadMyAccess', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyAccessSearchAndEditCompanyAccessPut operation.
     * @callback module:api/UserCompanyAccessApi~userCompanyAccessSearchAndEditCompanyAccessPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchAndEditCompanyAccess
     * @param {String} _4SAPIAppID 
     * @param {module:model/UserCompanyAccess} body 
     * @param {module:api/UserCompanyAccessApi~userCompanyAccessSearchAndEditCompanyAccessPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userCompanyAccessSearchAndEditCompanyAccessPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyAccessSearchAndEditCompanyAccessPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userCompanyAccessSearchAndEditCompanyAccessPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/UserCompanyAccess/searchAndEditCompanyAccess', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyAccessSetPartnerClientCompanyAccessesForUserPut operation.
     * @callback module:api/UserCompanyAccessApi~userCompanyAccessSetPartnerClientCompanyAccessesForUserPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setPartnerClientCompanyAccessesForUser
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} userID 
     * @param {module:api/UserCompanyAccessApi~userCompanyAccessSetPartnerClientCompanyAccessesForUserPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userCompanyAccessSetPartnerClientCompanyAccessesForUserPut = function(_4SAPIAppID, body, userID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyAccessSetPartnerClientCompanyAccessesForUserPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userCompanyAccessSetPartnerClientCompanyAccessesForUserPut";
      }

      // verify the required parameter 'userID' is set
      if (userID == undefined || userID == null) {
        throw "Missing the required parameter 'userID' when calling userCompanyAccessSetPartnerClientCompanyAccessesForUserPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'userID': userID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/UserCompanyAccess/setPartnerClientCompanyAccessesForUser', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
